var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEmployeeFactory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 4.38H12.08C11.72 2.58667 10.2533 1.26 8.5 1.04667V0H7.5V1.04667C5.74667 1.26667 4.28667 2.59333 3.92 4.38H3.33333V5.38H4.5V5.5C4.5 7.43333 6.06667 9 8 9C9.93333 9 11.5 7.43333 11.5 5.5V5.38H12.6667V4.38ZM7.5 2.04667V3H8.5V2.04667C9.71333 2.24667 10.7133 3.16 11.0467 4.38H4.96C5.28667 3.15333 6.28667 2.24667 7.5 2.04667ZM10.5 5.5C10.5 6.88 9.38 8 8 8C6.62 8 5.5 6.88 5.5 5.5V5.38H10.5V5.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10H6.5C4.56667 10 3 11.5667 3 13.5V15H4V13.5C4 12.6067 4.47333 11.8333 5.17333 11.3867V15.02H6.17333V11.0267C6.28 11.0133 6.38667 10.9933 6.5 10.9933H9.5C9.61333 10.9933 9.72 11.0133 9.82667 11.0267V15.02H10.8267V11.3867C11.5267 11.8267 12 12.6067 12 13.5V15H13V13.5C13 11.5667 11.4333 10 9.5 10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEmployeeFactory);
export default __webpack_public_path__ + "static/media/ic-employee-factory.df8676837dcf238fc6b73ee132d668db.svg";
export { ForwardRef as ReactComponent };